import type { CustomerErrorCode, Maybe } from "@shopify/hydrogen-react/storefront-api-types";

const ERROR_MESSAGES: Record<string, { en: string; jp: string; ko: string }> = {
  DEFAULT: {
    en: "An error occurred on the server. Please try again.",
    jp: "サーバーでエラーが発生しました。しばらくしてからもう一度お試しください。",
    ko: "서버에 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  },
  ALREADY_ENABLED: {
    en: "This account is already associated with another account.",
    jp: "すでに登録されているアカウント입니다.",
    ko: "이미 가입한 계정입니다.",
  },
  BAD_DOMAIN: {
    en: "This email address is not valid for use.",
    jp: "使用できないメールアドレスです。",
    ko: "사용할 수 없는 이메일 주소입니다.",
  },
  BLANK: {
    en: "This field cannot be blank.",
    jp: "値を入力してください。",
    ko: "값을 입력해 주세요.",
  },
  CONTAINS_HTML_TAGS: {
    en: "HTML tags are not allowed.",
    jp: "HTMLタグは入力できません。",
    ko: "HTML 태그는 입력할 수 없습니다.",
  },
  CONTAINS_URL: {
    en: "URLs are not allowed.",
    jp: "URLは入力できません。",
    ko: "URL은 입력할 수 없습니다.",
  },
  CUSTOMER_DISABLED: {
    en: "This account is deactivated.",
    jp: "非活性化されたアカウントです。",
    ko: "비활성화된 계정입니다.",
  },
  INVALID: {
    en: "The value cannot be allowed.",
    jp: "使用できない値です。",
    ko: "사용할 수 없는 값입니다.",
  },
  INVALID_MULTIPASS_REQUEST: {
    en: "Multipass token is not valid.",
    jp: "使用できない値입니다.",
    ko: "사용할 수 없는 값입니다.",
  },
  NOT_FOUND: {
    en: "Address does not exist.",
    jp: "存在しない住所です。",
    ko: "존재하지 않는 주소 입니다.",
  },
  PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE: {
    en: "Passwords cannot contain spaces.",
    jp: "パスワードに空白を入力することはできません。",
    ko: "비밀번호에는 공백 입력을 할 수 없습니다.",
  },
  TAKEN: {
    en: "This value has already been taken.",
    jp: "すでに登録されています。",
    ko: "이미 사용중인 값입니다.",
  },
  TOKEN_INVALID: {
    en: "The token is not valid.",
    jp: "使用できないトークン입니다.",
    ko: "사용할 수 없는 토큰입니다.",
  },
  TOO_LONG: {
    en: "The input exceeds the maximum length.",
    jp: "最大入力長を超えました。再度入力してください。",
    ko: "최대 입력 길이를 초과하였습니다. 다시 입력해 주세요.",
  },
  TOO_SHORT: {
    en: "Please input at least the minimum length.",
    jp: "最小入力長以上を入力してください。",
    ko: "최소 입력 길이만큼 입력해 주세요.",
  },
  UNIDENTIFIED_CUSTOMER: {
    en: "Email and password do not match.",
    jp: "メールアドレスまたはパスワードを誤って入力しました。",
    ko: "이메일 또는 비밀번호를 잘못 입력했습니다.",
  },
};

export const shopifyErrorHandler = (code: Maybe<CustomerErrorCode> | undefined, lang: "ko" | "en" | "jp"): string => {
  const safeCode = code ?? "DEFAULT";
  return ERROR_MESSAGES[safeCode][lang];
};
